import React from 'react';
import LogbookEntryList from './LogbookEntryList';
import Typography from '@mui/material/Typography';
import { useCurrentLogbook } from 'ff/debrief/hooks';

const ConnectLogbookForm = () => {
    const {
        suggestedItems,
        logbookEntries,
        isSuggestedLoading,
        isLogbookLoading,
    } = useCurrentLogbook();

    return (
        <>
            <Typography
                sx={{
                    position: 'sticky',
                    top: '0',
                    zIndex: 1,
                    fontWeight: '900',
                    fontSize: '11px',
                    backgroundColor: '#EFF1F3',
                    padding: '7px',
                    paddingLeft: '14px',
                    color: '#526f8a',
                }}
            >
                SUGGESTED ENTRIES
            </Typography>

            <LogbookEntryList
                entries={suggestedItems}
                isLoading={isSuggestedLoading}
                emptyMessage="No Logbook Suggestions Found"
            />

            <Typography
                sx={{
                    position: 'sticky',
                    top: '0',
                    zIndex: 1,
                    fontWeight: '900',
                    fontSize: '11px',
                    backgroundColor: '#EFF1F3',
                    padding: '7px',
                    paddingLeft: '14px',
                    color: '#526f8a',
                }}
            >
                RECENT ENTRIES
            </Typography>

            <LogbookEntryList
                entries={logbookEntries}
                isLoading={isLogbookLoading}
                emptyMessage="No Logbook Entries Available"
            />
        </>
    );
};

export default ConnectLogbookForm;
